import React, { useMemo } from 'react';
import { Challenge, ChallengeStatus } from '../../../types/Challenge';
import { StatusIndicator, StatusIndicatorStatus } from '../../common/StatusIndicator';
import { useTranslation } from 'react-i18next';
import { i18nKeys } from '@/src/utils/i18n.utils';

interface ChallengeStatusIndicatorProps {
  challenge: Challenge | undefined;
  subtitle: string;
  showVersion: boolean;
}

const ChallengeStatusIndicator: React.FC<ChallengeStatusIndicatorProps> = ({ challenge, showVersion }) => {
  const { t } = useTranslation();
  const { status, statusText } = useMemo<{
    status: StatusIndicatorStatus;
    statusText: string;
  }>(() => {
    if (challenge?.isArchived) {
      return {
        status: 'stopped',
        statusText: t(i18nKeys.general.archived).toLocaleUpperCase(),
      };
    }
    const version = showVersion && challenge ? `${challenge.majorVersion || 0}.${challenge.minorVersion || 0}` : '';
    const displayStatus = challenge?.status ?? ChallengeStatus.DRAFT;
    const statusText = version ? `${version}-${displayStatus}` : displayStatus;
    return {
      status: challenge?.status === ChallengeStatus.APPROVED ? 'success' : 'in-progress',
      statusText,
    };
  }, [challenge, showVersion]);

  return (
    <div>
      <StatusIndicator status={status} label={statusText} />
    </div>
  );
};

export default ChallengeStatusIndicator;
